import axios from '@axios'

export const state = {
  states: [],
  currentPage: 1,
  perPage: 15,
  totalPages: 1,
  totalRecord: 0,
}

export const getters = {
  allStates: (state) => state.states,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecord: (state) => state.totalRecord,
}

export const mutations = {
  GET_STATES: (state, resp) => {
    if (!resp) return null
    state.states = resp.states
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPages = resp.totalPages
    state.totalRecord = resp.totalRecords
  },
  CREATE_STATE: (state, _state) => {
    state.states.unshift(_state)
  },
  UPDATE_STATE: (state, _state) => {
    let clone = []
    for (let i = 0; i < state.states.length; i++) {
      if (state.states[i].id === _state.id) {
        clone[i] = _state
      } else {
        clone[i] = state.states[i]
      }
    }
    state.states = clone
  },
  DELETE_STATE: (state, _state) => {
    state.states = state.states.filter((s) => s.id !== _state.id)
  },
}

export const actions = {
  async getStates({ commit }, params) {
    await axios
      .get(`/api/states`, { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          let data = Object.assign({}, resp.data)
          commit('GET_STATES', data)
        }
      })
      .catch(() => {
        commit('GET_STATES', null)
      })
  },
  async createState({ commit }, state) {
    return axios.post('/api/state', state)
  },
  async updateState({ commit }, state) {
    return axios.put('/api/state', state)
  },

  async deleteState({ commit, dispatch }, state) {
    await axios.delete('/api/state', { data: state }).then((resp) => {
      if (resp.status === 204) {
        commit('DELETE_STATE', state)
        let notification = {
          id: Date.now(),
          type: 'success',
          title: 'DELETE',
          message: 'The state has been deleted',
        }
        dispatch('notification/addNotification', notification, { root: true })
      }
    })
  },
}
